import client from 'client'
import type {
  CreateNewAssetAssetPostMutationRequest,
  CreateNewAssetAssetPostMutationResponse,
  CreateNewAssetAssetPostQueryParams,
  CreateNewAssetAssetPost422,
} from '../../types/CreateNewAssetAssetPost.ts'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { RequestConfig, ResponseConfig, ResponseErrorConfig } from 'client'
import { useMutation } from '@tanstack/react-query'

export const createNewAssetAssetPostMutationKey = () => [{ url: '/asset' }] as const

export type CreateNewAssetAssetPostMutationKey = ReturnType<typeof createNewAssetAssetPostMutationKey>

/**
 * @summary Create New Asset
 * {@link /asset}
 */
export async function createNewAssetAssetPost(
  data?: CreateNewAssetAssetPostMutationRequest,
  params?: CreateNewAssetAssetPostQueryParams,
  config: Partial<RequestConfig<CreateNewAssetAssetPostMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<CreateNewAssetAssetPostMutationResponse, ResponseErrorConfig<CreateNewAssetAssetPost422>, CreateNewAssetAssetPostMutationRequest>({
    method: 'POST',
    url: `/asset`,
    params,
    data,
    ...requestConfig,
  })
  return res
}

/**
 * @summary Create New Asset
 * {@link /asset}
 */
export function useCreateNewAssetAssetPost(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateNewAssetAssetPostMutationResponse>,
      ResponseErrorConfig<CreateNewAssetAssetPost422>,
      { data?: CreateNewAssetAssetPostMutationRequest; params?: CreateNewAssetAssetPostQueryParams }
    >
    client?: Partial<RequestConfig<CreateNewAssetAssetPostMutationRequest>> & { client?: typeof client }
  } = {},
) {
  const { mutation: mutationOptions, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? createNewAssetAssetPostMutationKey()

  return useMutation<
    ResponseConfig<CreateNewAssetAssetPostMutationResponse>,
    ResponseErrorConfig<CreateNewAssetAssetPost422>,
    { data?: CreateNewAssetAssetPostMutationRequest; params?: CreateNewAssetAssetPostQueryParams }
  >({
    mutationFn: async ({ data, params }) => {
      return createNewAssetAssetPost(data, params, config)
    },
    mutationKey,
    ...mutationOptions,
  })
}